"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: account/account-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Faccount%2Faccount-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountServiceClient = exports.DisableForeignChargesResponse = exports.DisableForeignChargesRequest = exports.EnableForeignChargesResponse = exports.EnableForeignChargesRequest = exports.GetCardsResponse = exports.GetCardsRequest = exports.GetLimitStateResponse = exports.GetLimitStateRequest = exports.GetBalanceResponse = exports.GetBalanceRequest = exports.GetDefaultAccountResponse = exports.GetDefaultAccountRequest = exports.LookupSubAccountResponse = exports.LookupSubAccountRequest = exports.GetSubAccountsResponse = exports.GetSubAccountsRequest = exports.GetAccountsResponse = exports.GetAccountsRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const card_1 = require("../card/card");
const amount_1 = require("../common/amount");
const paging_1 = require("../paging/paging");
const account_1 = require("./account");
const limit_state_1 = require("./limit-state");
const protobufPackage = 'com.step.account.proto';
function createBaseGetAccountsRequest() {
    return { includeClosed: false, onlyActiveSubAccounts: false };
}
exports.GetAccountsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.includeClosed)) {
            message.includeClosed = globalThis.Boolean(object.includeClosed);
        }
        if (isSet(object.onlyActiveSubAccounts)) {
            message.onlyActiveSubAccounts = globalThis.Boolean(object.onlyActiveSubAccounts);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.includeClosed !== undefined && message.includeClosed !== false) {
            obj.includeClosed = message.includeClosed;
        }
        if (message.onlyActiveSubAccounts !== undefined && message.onlyActiveSubAccounts !== false) {
            obj.onlyActiveSubAccounts = message.onlyActiveSubAccounts;
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountsRequest();
        message.includeClosed = object.includeClosed ?? false;
        message.onlyActiveSubAccounts = object.onlyActiveSubAccounts ?? false;
        return message;
    },
};
function createBaseGetAccountsResponse() {
    return { accounts: [] };
}
exports.GetAccountsResponse = {
    fromJSON(object) {
        const message = {
            accounts: globalThis.Array.isArray(object?.accounts)
                ? object.accounts.map((e) => account_1.Account.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => account_1.Account.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountsResponse();
        message.accounts = object.accounts?.map((e) => account_1.Account.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetSubAccountsRequest() {
    return {
        primaryAccountId: '',
        filter: account_1.SubAccountFilter.INVALID_SUB_ACCOUNT_FILTER,
        paging: undefined,
    };
}
exports.GetSubAccountsRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            filter: isSet(object.filter)
                ? (0, account_1.subAccountFilterFromJSON)(object.filter)
                : account_1.SubAccountFilter.INVALID_SUB_ACCOUNT_FILTER,
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.filter !== account_1.SubAccountFilter.INVALID_SUB_ACCOUNT_FILTER) {
            obj.filter = (0, account_1.subAccountFilterToJSON)(message.filter);
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetSubAccountsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSubAccountsRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.filter = object.filter ?? account_1.SubAccountFilter.INVALID_SUB_ACCOUNT_FILTER;
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetSubAccountsResponse() {
    return { subAccounts: [], paging: undefined };
}
exports.GetSubAccountsResponse = {
    fromJSON(object) {
        const message = {
            subAccounts: globalThis.Array.isArray(object?.subAccounts)
                ? object.subAccounts.map((e) => account_1.AccountSubAccount.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subAccounts?.length) {
            obj.subAccounts = message.subAccounts.map((e) => account_1.AccountSubAccount.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetSubAccountsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSubAccountsResponse();
        message.subAccounts = object.subAccounts?.map((e) => account_1.AccountSubAccount.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseLookupSubAccountRequest() {
    return { accountId: '' };
}
exports.LookupSubAccountRequest = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.LookupSubAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupSubAccountRequest();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseLookupSubAccountResponse() {
    return { subAccount: account_1.AccountSubAccount.fromPartial({}) };
}
exports.LookupSubAccountResponse = {
    fromJSON(object) {
        const message = {
            subAccount: isSet(object.subAccount)
                ? account_1.AccountSubAccount.fromJSON(object.subAccount)
                : account_1.AccountSubAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subAccount !== undefined) {
            obj.subAccount = account_1.AccountSubAccount.toJSON(message.subAccount);
        }
        return obj;
    },
    create(base) {
        return exports.LookupSubAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupSubAccountResponse();
        message.subAccount = (object.subAccount !== undefined && object.subAccount !== null)
            ? account_1.AccountSubAccount.fromPartial(object.subAccount)
            : account_1.AccountSubAccount.fromPartial({});
        return message;
    },
};
function createBaseGetDefaultAccountRequest() {
    return {};
}
exports.GetDefaultAccountRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetDefaultAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetDefaultAccountRequest();
        return message;
    },
};
function createBaseGetDefaultAccountResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.GetDefaultAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.GetDefaultAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDefaultAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseGetBalanceRequest() {
    return { primaryAccountId: undefined, subAccountId: undefined };
}
exports.GetBalanceRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        if (isSet(object.subAccountId)) {
            message.subAccountId = globalThis.String(object.subAccountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== undefined) {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.subAccountId !== undefined) {
            obj.subAccountId = message.subAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetBalanceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetBalanceRequest();
        message.primaryAccountId = object.primaryAccountId ?? undefined;
        message.subAccountId = object.subAccountId ?? undefined;
        return message;
    },
};
function createBaseGetBalanceResponse() {
    return { available: amount_1.Amount.fromPartial({}) };
}
exports.GetBalanceResponse = {
    fromJSON(object) {
        const message = {
            available: isSet(object.available)
                ? amount_1.Amount.fromJSON(object.available)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.available !== undefined) {
            obj.available = amount_1.Amount.toJSON(message.available);
        }
        return obj;
    },
    create(base) {
        return exports.GetBalanceResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetBalanceResponse();
        message.available = (object.available !== undefined && object.available !== null)
            ? amount_1.Amount.fromPartial(object.available)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseGetLimitStateRequest() {
    return { primaryAccountId: '' };
}
exports.GetLimitStateRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetLimitStateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLimitStateRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function createBaseGetLimitStateResponse() {
    return { limits: [] };
}
exports.GetLimitStateResponse = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.limits)) {
            message.limits = object.limits.map((e) => limit_state_1.LimitState.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.limits?.length) {
            obj.limits = message.limits.map((e) => limit_state_1.LimitState.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetLimitStateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLimitStateResponse();
        message.limits = object.limits?.map((e) => limit_state_1.LimitState.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetCardsRequest() {
    return { primaryAccountId: '', includeClosed: false };
}
exports.GetCardsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        if (isSet(object.includeClosed)) {
            message.includeClosed = globalThis.Boolean(object.includeClosed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== undefined && message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.includeClosed !== undefined && message.includeClosed !== false) {
            obj.includeClosed = message.includeClosed;
        }
        return obj;
    },
    create(base) {
        return exports.GetCardsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCardsRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.includeClosed = object.includeClosed ?? false;
        return message;
    },
};
function createBaseGetCardsResponse() {
    return { cards: [] };
}
exports.GetCardsResponse = {
    fromJSON(object) {
        const message = {
            cards: globalThis.Array.isArray(object?.cards)
                ? object.cards.map((e) => card_1.Card.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cards?.length) {
            obj.cards = message.cards.map((e) => card_1.Card.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetCardsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCardsResponse();
        message.cards = object.cards?.map((e) => card_1.Card.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEnableForeignChargesRequest() {
    return {};
}
exports.EnableForeignChargesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnableForeignChargesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnableForeignChargesRequest();
        return message;
    },
};
function createBaseEnableForeignChargesResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.EnableForeignChargesResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.EnableForeignChargesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnableForeignChargesResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseDisableForeignChargesRequest() {
    return {};
}
exports.DisableForeignChargesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DisableForeignChargesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDisableForeignChargesRequest();
        return message;
    },
};
function createBaseDisableForeignChargesResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.DisableForeignChargesResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.DisableForeignChargesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisableForeignChargesResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
/**
 * Account Service API.
 *
 * Manages a user accounts. A user records must be created first before opening
 * an account. The user also needs to be onboarded/KYCed before doing that.
 */
class AccountServiceClient {
    rpc;
    name = 'com.step.account.proto.AccountService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/account';
    methods = [{
            name: 'Get',
            requestType: exports.GetAccountsRequest,
            responseType: exports.GetAccountsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetSubAccounts',
            requestType: exports.GetSubAccountsRequest,
            responseType: exports.GetSubAccountsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'LookupSubAccount',
            requestType: exports.LookupSubAccountRequest,
            responseType: exports.LookupSubAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetDefault',
            requestType: exports.GetDefaultAccountRequest,
            responseType: exports.GetDefaultAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetBalance',
            requestType: exports.GetBalanceRequest,
            responseType: exports.GetBalanceResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetLimitState',
            requestType: exports.GetLimitStateRequest,
            responseType: exports.GetLimitStateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCards',
            requestType: exports.GetCardsRequest,
            responseType: exports.GetCardsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EnableForeignCharges',
            requestType: exports.EnableForeignChargesRequest,
            responseType: exports.EnableForeignChargesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'DisableForeignCharges',
            requestType: exports.DisableForeignChargesRequest,
            responseType: exports.DisableForeignChargesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Returns all the accounts the user has access to.
     */
    get(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a paged list of all the sub-accounts for the specified primary
     * account id.
     */
    getSubAccounts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the sub-account for the specified sub-account id. This would
     * typically be used to retrieve a specific sub-account which may be closed,
     * and thus not in the listed active sub-accounts for the account.
     */
    lookupSubAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the default account for the user.
     */
    getDefault(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns user account balance.
     */
    getBalance(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Account limits and their state to display in the client app
     */
    getLimitState(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns all of the issued cards for the given account.
     */
    getCards(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Enable international card charges.
     */
    enableForeignCharges(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Disable international card charges.
     */
    disableForeignCharges(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.AccountServiceClient = AccountServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=account-service.js.map